import { render } from "./index.vue?vue&type=template&id=b46303f0"
import script from "./script?vue&type=script&lang=js&external"
export * from "./script?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__